<template>
    <div>
        <b-container v-if="node">
            <b-row>
                <b-col
                    class="d-flex justify-content-center align-items-center mb-3"
                    style="flex-direction: column;"
                >
                    <!--<h1>{{isEra ? 'Era' : 'Event'}}</h1>-->
                    <best-fit-text style="display: block; width: 100%; text-align: center;">
                        {{ name }}
                    </best-fit-text>
                    <h6 v-if="node && node.important">
                        (Important)
                    </h6>
                </b-col>
            </b-row>
            <b-row v-if="isEvent">
                <b-col style="margin-top: 10px;">
                    <div style="width: 90%; margin: auto;">
                        <b-img
                            v-show="isImageLoaded"
                            style="width: 100%; max-height: 50vh; object-fit: contain;"
                            :src="imageUrl"
                            :aria-label="(imageUrl == null || imageUrl == '') ? 'placeholder image' : name"
                        />
						
                        <div 
                            v-show="isImageLoaded && imageUrl != null && imageUrl != '' && node.imageCaption != null"
                            style="font-size: 80%;"
                            aria-hidden="true"
                        >
                            {{ node.imageCaption }}
                        </div>

                        <!-- This isn't set up as best as it can be, but meh -->
                        <div
                            v-if="!isImageLoaded"
                            style="background-color: #363A3E; width: 100%; height: 300px;"
                        >
                            <div
                                style="width: 100%; height: 100%;"
                                class="d-flex justify-content-center mb-3"
                            >
                                <div style="margin: auto;">
                                    <b-spinner variant="light" />
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="validatingAudio">
                <div
                    style="width: 100%;margin-top: 10px;"
                    class="d-flex justify-content-center mb-3"
                >
                    <div style="margin: auto;">
                        <b-spinner />
                    </div>
                </div>
            </b-row>
            <b-row v-else-if="node.audio">
                <b-col style="margin-top: 10px;">
                    <audio
                        style="width: 90%; display: block; margin: auto;"
                        controls="controls"
                    >
                        <source :src="node.audio_url">
                        Your browser does not support the HTML5 Audio element.
                    </audio>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="margin-top: 10px;">
                    <p
                        style="font-size: 26px; width: 100%; text-align: center;"
                        :aria-label="`from ${dateStart} to ${dateEnd}`"
                    >
                        {{ dateStart }} - {{ dateEnd }}
                    </p>
                </b-col>
            </b-row>
			
            <!-- Description/references -->
            <b-row>
                <b-col>
                    <b-form-group label="Name">
                        <b-form-input-limited
                            v-model="editName"
                            :maxlength="50"
                            placeholder="Enter a name here"
                            label="name"
                            :state="editName.trim() !== ''"
                            autofocus
                        />
                    </b-form-group>
                    <b-checkbox
                        v-model="editImportant"
                        style="margin-bottom: 1rem;"
                    >
                        Important
                    </b-checkbox>
                    <b-form-group
                        v-if="isEvent"
                        label="Description"
                    >
                        <b-form-textarea-limited
                            v-model="editDescription"
                            :maxlength="2500"
                            label="description"
                        />
                    </b-form-group>
                    <node-date-options-selector :node="node" />
                    <node-date-picker
                        ref="startDatePicker"
                        start
                        :node="node"
                        @date-changed="startDateChanged"
                    />
                    <node-date-picker
                        ref="endDatePicker"
                        end
                        :node="node"
                        @date-changed="endDateChanged"
                    />
                    <b-form-group
                        v-if="isEvent"
                        label="Image URL"
                    >
                        <b-row>
                            <b-form-input-limited
                                v-model="editImageURL"
                                style="width: 84%; margin-left: 14px"
                                :maxlength="300"
                                placeholder="Paste a direct link to an image (.jpg, .jpeg, .png, .gif, .tiff) here"
                                label="image URL"
                                :disabled="validatingImage"
                                :state="editImageURL === '' || editImageURLValid"
                            />
                            <b-btn
                                v-b-tooltip.hover="'image uploads'"
                                style="height: 38px; margin-left: 5px; padding: 0 0 0 5px; width: 10%; max-width: 48px"
                                variant="cliovis-blue-light"
                                aria-label="image uploads"
                                @click="$refs.uploadListModal.show(), displayImageUploads=true"
                            >
                                <i
                                    class="fas fa-folder-open"
                                    aria-hidden="true"
                                />
                            </b-btn>
                        </b-row>
                        <b-form-valid-feedback :state="validatingImage">
                            <span style="float: right; margin-top: -24px">Loading...</span>
                        </b-form-valid-feedback>
                        <b-alert
                            v-if="errorMsg != null" 
                            variant="danger" 
                            style="font-size: smaller; white-space: pre-line"
                            show
                        >
                            <span style="padding: 0">{{ errorMsg }}</span>
                        </b-alert>
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Image Caption"
                    >
                        <b-form-textarea-limited
                            v-model="editImageCaption"
                            :maxlength="200"
                            label="image caption"
                        />
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Audio Clip URL"
                    >
                        <b-row>
                            <b-form-input-limited
                                v-model="editAudioURL"
                                style="width: 84%; margin-left: 14px"
                                :maxlength="300"
                                placeholder="Paste a direct link to an audio file (.mp3, .m4a, .wav, .ogg) here"
                                label="audio URL"
                                :disabled="validatingAudio"
                                :state="editAudioURL === '' || editAudioURLValid"
                            />
                            <b-btn
                                v-b-tooltip.hover="'audio uploads'"
                                style="height: 38px; margin-left: 5px; padding: 0 0 0 5px; width: 10%; max-width: 48px"
                                variant="cliovis-blue-light"
                                aria-label="audio uploads"
                                @click="$refs.uploadListModal.show(), displayImageUploads=false"
                            >
                                <i
                                    class="fas fa-folder-open"
                                    aria-hidden="true"
                                />
                            </b-btn>
                        </b-row>
                        <b-form-valid-feedback :state="validatingAudio">
                            <span style="float: right; margin-top: -24px">Loading...</span>
                        </b-form-valid-feedback>	
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="References"
                    >
                        <b-form-textarea-limited
                            v-model="editReferences"
                            :maxlength="1000"
                            label="references"
                        />
                    </b-form-group>
                    <b-form-group
                        v-if="isEvent"
                        label="Category"
                    >
                        <b-form-select
                            v-model="editTag"
                            aria-label="categories dropdown"
                        >
                            <option :value="null">
                                None
                            </option>
                            <option
                                v-for="(tag, key) in tagOptions"
                                :key="key"
                                :value="tag"
                            >
                                {{ tag.name }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                    <b-checkbox
                        v-if="!isEvent"
                        v-model="useDefaultColor"
                    >
                        Use Default Color
                    </b-checkbox>
                    <color-slider 
                        v-if="!isEvent && !useDefaultColor"
                        :node="node"
                        create-mode
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-btn
                        block
                        @click="close"
                    >
                        Cancel <span style="color: white; font-size: 64%;">(C)</span>
                    </b-btn>
                </b-col>
                <b-col>
                    <b-btn
                        v-if="editing"
                        variant="cliovis-blue-light"
                        block
                        :disabled="!formValid"
                        @click="create"
                    >
                        <i class="fas fa-plus-circle" /> Create
                    </b-btn>
                </b-col>
            </b-row>
        </b-container>
        <b-modal
            ref="confirmCloseModal"
            size="lg"
            :centered="true"
            title="Confirm Close"
        >
            Are you sure you want to close the creator panel? You will lose the data you entered into the creator if you close it.
            <template slot="modal-footer">
                <b-btn @click="$refs.confirmCloseModal.hide()">
                    Keep Creator Open
                </b-btn>
                <b-btn
                    variant="danger"
                    @click="close(null, true)"
                >
                    Close Creator
                </b-btn>
            </template>
        </b-modal>

        <b-modal
            ref="uploadListModal"
            centered
            title="Uploads"
            cancel-variant="cliovis-blue-light"
            cancel-title="Upload File"
            ok-variant="secondary"
            ok-title="Close"
            size="lg"
            @cancel="$refs.uploadModal.show()"
        >
            <template #modal-cancel>
                <i class="fas fa-file-upload" /> Upload File
            </template>
            <upload-list
                v-if="displayImageUploads"
                add-link
                just-images
                @close="addLinkAndHideModal"
            />
            <upload-list
                v-else
                add-link
                just-audio
                @close="addLinkAndHideModal"
            />
        </b-modal>
    </div>	
</template>

<script>
/* eslint-disable no-unused-vars */
import { Num } from 'docx';
import { Audio, AudioListener } from 'three';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import BestFitText from "@/components/BestFitText.vue";
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import BFormTextareaLimited from '@/components/input_limited/BFormTextareaLimited.vue';
import ColorSlider from '@/components/ColorSlider.vue';
import NodeDateOptionsSelector from '@/components/NodeDateOptionsSelector.vue';
import NodeDatePicker from '@/components/NodeDatePicker.vue';
import Upload from '@/components/Upload.vue';
import UploadList from '@/components/UploadList.vue';
import DateOptions from '@/models/DateOptions';
import Node, { NodeType } from '@/models/Node';
import { PacketType } from '@/models/Packet';
import ProjectServer from '@/models/ProjectServer';
import Timeline from '@/models/Timeline';
import { SendPacket } from '@/networking/SendPacket';
import Mutations from '@/store/mutations';
import { handleImageSpecialCases } from '@/util/ImageUtil';

const CreateTypes = 
{
    None: -1,
    Node: 0,
    Era: 1
};

export default Vue.extend({
    components:
	{
	    BFormTextareaLimited,
	    BFormInputLimited,
	    NodeDatePicker,
	    NodeDateOptionsSelector,
	    BestFitText,
	    UploadList,
	    // eslint-disable-next-line vue/no-unused-components
	    Upload,
	    ColorSlider
	},
    props: 
	{
	    // eslint-disable-next-line vue/require-default-prop
	    type : Number,
	    timeline : Timeline
	},
    data()
    {
        return {
            node: null,
            forceUpdateDate: false,
            forceUpdateImgUrl: false,
            editImgSrc: "",
            editAudioSrc: "",
            validatingAudio: false,
            validatingImage: false,
            errorMsg: null,
            displayImageUploads: false,
            dateInput:
			{
			    startMonth: undefined,
			    startDay: undefined,
			    startYear: undefined,
			    startBCE: false,
			    endMonth: undefined,
			    endDay: undefined,
			    endYear: undefined,
			    endBCE: false
			},
            useDefaultColor: true
        };
    },
    computed: {
        ...mapGetters([
            'nodes',
            'timelineFormMode'
        ]),
        tagOptions()
        {
            return this.timeline.tags;
        },
        editing()
        {
            return true;
        },
        // Editing
        editName:
		{
		    get()
		    {
		        return this.node.name;
		    },
		    set(value) 
		    {
		        this.node.name = value;
		    }
		},

        editImportant:
		{
		    get()
		    {
		        return this.node.important;
		    },
		    set(value)
		    {
		        this.node.important = value;
		    }
		},

        editDescription:
		{
		    get() 
		    {
		        return this.node.description;
		    },
		    set(value) 
		    {
		        this.node.description = value;
		    }
		},
		
        editReferences:
		{
		    get() 
		    {
		        return this.node.references;
		    },
		    set(value) 
		    {
		        this.node.references = value;
		    }
		},

        editTag:
		{
		    get()
		    {
		        return this.node.tags.length == 0 ? null : this.node.tags[0];
		    },
		    set(value)
		    {
		        // clear
		        this.node.tags.length = 0;
		        // add
		        if (value)
		        {
		            this.node.tags.push(value);
		        }
		    }
		},

        editAudioURLValid()
        {
            return this.editAudioSrc == this.node.audio;
        },

        editAudioURL: 
		{
		    get()
		    {
		        return this.editAudioSrc;
		    },
		    set(value) 
		    {
		        this.editAudioSrc = value;
		        if (value.trim() == '')
		        {
		            this.node.audio = '';
		            return;
		        }
		        if (value.match(/[Hh][Tt][Tt][Pp]([Ss])?:\/\//))
		        {
		            // TODO (ian): Make this actually use the HTML5 Audio API to validate that it is a valid audio file
		            /*
					let audio = new Audio(value);
					audio.src = value;
					audio.onload = () =>
					{
						this.node.image = value;
						SendPacket(PacketType.NodeUpdateAudio, 
						{
							nodeid: this.node.nodeid, 
							value: this.node.audio
						});
					}
					audio.onerror = () =>
					{
						
					}
					*/
		            if (value.toLowerCase().match(/((\.wav)|(\.mp3)|(\.m4a)|(\.ogg))$/))
		            {
		                this.validatingAudio=true;
		                this.$http.get(`audio?url=${value}`).then(
		                    (resp) =>
		                    {
		                        this.node.audio = value;
		                        this.validatingAudio=false;
		                    },
		                    () =>
		                    {
		                        this.validatingAudio=false;
		                    }
		                );
		            }
		        }
		    }
		},

        editImageURLValid()
        {
            return this.editImgSrc == this.node.image;
        },
		
        editImageURL: 
		{
		    get()
		    {
		        return this.editImgSrc;
		    },
		    set(value) 
		    {
		        console.log(`og: ${value}`);
		        value = handleImageSpecialCases(value);
		        console.log(`edited: ${value}`);
		        this.editImgSrc = value;
		        if (value.trim() == '')
		        {
		            this.node.image = '';
		            return;
		        }
		        if (value.match(/[Hh][Tt][Tt][Pp]([Ss])?:\/\//))
		        {
		            if (value.toLowerCase().match(/((\.gif)|(\.jpg)|(\.jpeg)|(\.png)|(\.svg)|(\.tiff))(\?[A-Za-z=?&%0-9]+)?$/))
		            {
		                let image = new Image();
		                image.src = value;
		                this.validatingImage = true;
		                image.onload = ()=>
		                {
		                    this.node.image = value;
		                    this.validatingImage = false;
		                };
		                image.onerror = ()=>
		                {
		                    this.errorMsg = "Please make sure that the URL is correct and the image you'd like to use is the only thing on the URL's web page.";
		                    this.validatingImage = false;
		                };
		            }
		            else
		            {
		                this.errorMsg = "The URL should include an image file extension: .gif, .jpg, .jpeg, .png, .svg, or .tiff";
		            }
		        }
		        else if(value.length > 7)
		        {
		            this.errorMsg = "A valid image URL starts with either http:// or https://\n\n" +
					"If you'd like to use an image that's on your computer then you need to upload it and then use the generated URL. You can do so by going to:\n\n" +
					"Uploads & Snapshots -> Upload File";
		        }
		    }
		},

        editImageCaption:
		{
		    get()
		    {
		        return this.node.imageCaption;
		    },
		    set(value) 
		    {
		        this.node.imageCaption = value;
		    }
		},

        // Getters
        isNodeImageValid() 
        {
            return this.node.image.trim() != '';
        },
        loadedImage() 
        {
            console.log("LOADING");
            let img = new Image();
            img.src = this.rawImageUrl;
            if (!img.complete)
            {
                console.log("Image not cached");
                img.onload = () =>
                {
                    console.log('Image fully loaded');
                    this.forceUpdateImgUrl = !this.forceUpdateImgUrl;
                };
            }
            return img;
        },
        rawImageUrl() 
        {
            if (this.node.image.trim() == '')
            {
                return this.timelineFormMode ? '' : '/images/placeholder_img.png';
            }
            return this.node.image;
        },
        isImageLoaded() 
        {
            if (!(this.rawImageUrl))
            {
                return true;
            }
            if (this.forceUpdateImgUrl && !this.forceUpdateImgUrl)
            {
                console.log('update!');
            }
            return this.loadedImage.complete;
        },
        imageUrl() 
        {
            this.forceUpdateImgUrl;
            let rawURL = this.rawImageUrl;
            return rawURL;
        },
        isEvent() 
        {
            return this.node.isEvent();
        },
        isEra() 
        {
            return this.node.isEra();
        },
        name() 
        {
            return this.node.name;
        },

        yearStart() 
        {
            this.forceUpdateDate;
            if (this.node.dateStart == null)
                return '';
            let year = this.node.dateStart.getUTCFullYear();
            if (year < 0)
                return (-year).toString() + " BCE";
            return year.toString();
        },
        yearEnd() 
        {
            this.forceUpdateDate;
            if (this.node.dateEnd == null)
                return '';
            let year = this.node.dateEnd.getUTCFullYear().toString();
            if (year < 0)
                return (-year).toString() + " BCE";
            return year.toString();
        },
        dateStart() 
        {
            this.forceUpdateDate;
            if (this.node.dateStart == null)
                return '';
            let date = this.node.dateStart.getUTCBCString(this.node.dateOptions);
            return date;
        },
        dateEnd()
        {
            this.forceUpdateDate;
            if (this.node.dateEnd == null)
                return '';
            let date = this.node.dateEnd.getUTCBCString(this.node.dateOptions);
            return date;
        },

        formValid() 
        {
            return this.editName != '' 
				&& !this.validatingImage && !this.validatingAudio 
				&& this.editAudioURLValid && this.editImageURLValid
				&& this.node.dateStart != null && !isNaN(this.node.dateStart)
				&& this.node.dateEnd != null && !isNaN(this.node.dateEnd);
        },
    },
    watch: {
        'node.image'(cur, old)
        {
            this.editImgSrc = cur;
        }
    },
    mounted()
    {
        let n = new Node;
        if (this.type == CreateTypes.Era)
        {
            n.type = NodeType.TimelineEra;
        }
        else
        {
            n.type = NodeType.TimelineEvent;
        }
        n.dateStart = null;
        n.dateEnd = null;
        n.dateOptions = new DateOptions(0);
        this.$set(this, "node", n);
        this.edit();
    },
    methods: 
	{
	    startDateChanged()
	    {
	        this.forceUpdateDate = !(this.forceUpdateDate);
	        this.$refs.endDatePicker.updateDate(); // check if the date is valid (won't cause unneeded mutations/packets)
	    },
	    endDateChanged()
	    {
	        this.forceUpdateDate = !(this.forceUpdateDate);
	        this.$refs.startDatePicker.updateDate(); // check if the date is valid (won't cause unneeded mutations/packets)
	    },
	    close(ev, override = false)
	    {
	        if (override)
	        {
	            this.$refs.confirmCloseModal.hide();
	            this.useDefaultColor = true;
	            this.$emit('close');
	        }
	        else
	        {
	            if (this.editName != '' || this.editDescription != '' || this.editReferences != ''
					|| (this.editAudioURL != '' && this.editAudioURLValid) 
					|| (this.editImageURL != '' && this.editImageURLValid)
					|| (this.node.dateStart != null && !isNaN(this.node.dateStart))
					|| (this.node.dateEnd != null && !isNaN(this.node.dateEnd)))
	            {
	                this.$refs.confirmCloseModal.show();
	            }
	            else
	            {
	                this.$refs.confirmCloseModal.hide();
	                this.useDefaultColor = true;
	                this.$emit('close');
	            }
	        }
	    },
	    edit() 
	    {
	        this.editImgSrc = this.node.image;
	        this.editAudioSrc = this.node.audio;
	    },
	    create()
	    {
	        if (this.timeline == null)
	        {
	            alert('Failed to create node: Could not get reference to timeline');
	            return;
	        }

	        if (this.useDefaultColor || this.isEvent)
	        {
	            this.node.color = null;
	        }
	        // else
	        // {
	        //     // TODO: improve if/when node creation packet becomes awaitable packet
	        //     const name = this.node.name;
	        //     const color = this.node.color;
	        //     let cb = ProjectServer.instance.registerCallback(PacketType.NodeCreate, (data) =>
	        //     {
	        //     	if (data.name.substring(1) === name)
	        //     	{
	        //     		this.$store.commit(Mutations.updateNodeColor, 
	        //     		{ 
	        //     			nodeid: data.nodeid, 
	        //     			color: color
	        //     		});
	        //     		SendPacket(PacketType.NodeUpdateColor,
	        //     		{
	        //     			nodeid: data.nodeid,
	        //     			color: color
	        //     		});
	        //     		ProjectServer.instance.removeCallback(PacketType.NodeCreate, cb);
	        //     	}
	        //     });
	        // }
	        Node.create(this.node, this.timeline.id);
			
	        this.useDefaultColor = true;
	        this.$emit('close');
	    },
	    addLinkAndHideModal(str, image)
	    {
	        this.$refs.uploadListModal.hide();
	        if(image)
	        {
	            let image = new Image();
	            image.src = str;
	            this.editImgSrc = image.src;
	            this.validatingImage = true;
	            image.onload = () =>
	            {
	                this.node.image = str;
	                SendPacket(PacketType.NodeUpdateImage, {nodeid: this.node.nodeid, value: this.node.image});
	                this.validatingImage = false;
	            };
	            image.onerror = () =>
	            {
	                this.validatingImage = false;
	            };
	        }
	        else
	        {
	            this.editAudioSrc = str;
	            this.validatingAudio = true;
	            this.$http.get(`audio?url=${str}`).then(
	                (resp) =>
	                {
	                    this.node.audio = str;
	                    this.validatingAudio = false;
	                    SendPacket(PacketType.NodeUpdateAudio, {nodeid: this.node.nodeid, value: this.node.audio});
	                },
	                () =>
	                {
	                    this.validatingAudio = false;
	                }
	            );
	        }
	    }
	}
});
</script>

<style lang="scss" scoped>

</style>